import { render, staticRenderFns } from "./FormProcedimento.vue?vue&type=template&id=566a8fb1&"
import script from "./FormProcedimento.vue?vue&type=script&lang=js&"
export * from "./FormProcedimento.vue?vue&type=script&lang=js&"
import style0 from "./FormProcedimento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports